// extracted by mini-css-extract-plugin
export default {"question":"KnowledgeQuizQuestion_question__ZGOHD"};